import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/guide/getting-started/CopyPromptButton.tsx");
